// RemixPlugin.js
// @author: anghello

import React, { useCallback, useEffect, useState } from 'react';

const EMBEDDED_PLUGIN_URL = process.env.REACT_APP_EMBEDDED_PLUGIN_FRAME;

export default function RemixPlugin({ remix, rid }) {
  const [embedPluginUrl, setEmbedPluginUrl] = useState(EMBEDDED_PLUGIN_URL);

  useEffect(() => {
    const host = window.location.host;
    if ((!host.includes('wwwt11') && !host.includes('localhost')) && host.includes('www')) {
      const currentUrl = embedPluginUrl;
      // setEmbedPluginUrl(currentUrl.replace('https://', 'https://www.'))
      setEmbedPluginUrl(currentUrl.replace('https://', 'https://'))
    }
  }, [embedPluginUrl, setEmbedPluginUrl]);

  const renderRemixIframe = useCallback((rid) => {
    return (
      <iframe
        width='640'
        height='360'
        src={`${embedPluginUrl}?remixid=${rid}&nooverbottomstartag&noovertopstartag&refreshonrestartbtn`}
        title='Remix PLUGIN'
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        style={{ maxWidth: '100%', height: 'auto', aspectRatio: '16/9' }}
      />
    );
  }, [embedPluginUrl]);

  return (
    <div>
      {remix && remix.rid && renderRemixIframe(remix.rid)}
      {rid && renderRemixIframe(rid)}
    </div>
  );
}
